import React from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';
import { Text } from '@atlaskit/primitives/compiled';

import lightModeInlineComment from '../images/lightModeInlineComment.gif';
import darkModeInlineComment from '../images/darkModeInlineComment.gif';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentContainer = styled.div({
	width: '241px',
	height: '214px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: `${token('space.200')} ${token('space.300')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& h1': {
		font: token('font.heading.medium'),
		marginBottom: `${token('space.150')}`,
	},
});

const formattedMessageValues = {
	b: (str: React.ReactNode[]) => <Text as="strong">{str}</Text>,
};

export const inlineCommentGifContent = () => (
	<ContentContainer data-cy="inline-comment-gif">
		<FormattedMessage
			id="inline-comments-common.heading"
			defaultMessage="Be the first to add an inline comment"
			description="Heading Section for Inline Comments discoverability Dialog"
			tagName="h1"
		/>
		<Image
			src={`${lightModeInlineComment}?${new Date().getTime()}`}
			srcDark={`${darkModeInlineComment}?${new Date().getTime()}`}
			alt=""
		/>
		<FormattedMessage
			id="inline-comments-common.message"
			defaultMessage="Share your feedback or ask a question by highlighting text and selecting <b>Comment</b>."
			description="Paragraph Section for Inline Comments discoverability Dialog"
			tagName="p"
			values={formattedMessageValues}
		/>
	</ContentContainer>
);
